import { jsx as _jsx } from "react/jsx-runtime";
var Report2 = function Report2(_ref) {
  var className = _ref.className,
    _ref$color = _ref.color,
    colorProp = _ref$color === void 0 ? '#181B32' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size,
    ignoreColor = _ref.ignoreColor;
  var color = !ignoreColor ? colorProp : undefined;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: /*#__PURE__*/_jsx("path", {
      d: "M5 4a1 1 0 0 0-1 1v14a1 1 0 0 0 1 1h6.5a1 1 0 1 1 0 2H5a3 3 0 0 1-3-3V5a3 3 0 0 1 3-3h7a1 1 0 0 1 .707.293l5 5A1 1 0 0 1 18 8v2a1 1 0 1 1-2 0V9h-3a2 2 0 0 1-2-2V4H5Zm8 1.414L14.586 7H13V5.414Zm3 8.757A3.001 3.001 0 1 0 19.83 18H17a1 1 0 0 1-1-1v-2.83Zm2 0V16h1.83A3.009 3.009 0 0 0 18 14.17ZM12 17a5 5 0 1 1 10 0 5 5 0 0 1-10 0Z",
      fill: color
    })
  });
};
export default Report2;